/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.accordionSection", {
        options: {
            header: 'h3',
            active: 0,
            useOptsActive:false // if true will skip active by data
        },

        _create: function () {
            this.acc = this.element;

            var activeItm

            if(this.options.useOptsActive){
                activeItm = this.options.active;
            }else{
                activeItm = api.fn.getData(this.acc, "active", 0);
            }

            var qsHeaderId = api.fn.getParameterByName("q");
            var header = null;

            if (qsHeaderId) {
                header = this.acc.find("#" + qsHeaderId);

                if (header.length) {
                    activeItm = Math.floor(header.index() / 2);
                }
            }

            var animate = api.fn.getData(this.acc, 'animate', 200);

            this.acc.accordion({
                navigation: true,
                animate: animate,
                header: this.options.header,
                heightStyle: "content",
                collapsible: true,
                active: activeItm,
                create: function (event, ui) {
                    if (activeItm >= 0 && qsHeaderId && header.length) {
                        api.fn.moveWindowToObj(header)
                    }
                },
                beforeActivate: function (event, ui) {
                },
                activate: function (event, ui) {

                    setTimeout(()=>{
                        jQuery(document.body).trigger("accordion-activated");
                    }, animate)
                }
            });


        },
    });
})(jQuery);
